export const RESTAURANT = '/restaurant/:entryIdToExpand?';
export const ABOUT = '/about';
export const CART = '/cart';
export const ORDER = '/order/:orderId/:isReview?';


